// extracted by mini-css-extract-plugin
module.exports = {"logout":"Logout_logout__2s5PR"};